import { BigFormRow, FormSection } from 'framework/ui/layout';
import { useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { Grid2 as Grid } from '@mui/material';
import { useFormContext, CommaListInput, TextInput, WysiwygInput } from 'framework/form';
import { useDocumentUiConfiguration } from 'infrastructure/documentUiConfiguration';
import AddIcon from '@mui/icons-material/AddOutlined';

const SendEmailForm = () => {
  const { EmailAttachmentUploaderInput, emailAttachmentArtifactTypeId } = useDocumentUiConfiguration();
  const {
    //@ts-ignore
    data: { ccs },
  } = useFormContext();
  const [isCcInputVisible, setIsCcInputVisible] = useState(!!ccs?.length);

  const showCcInput = () => {
    setIsCcInputVisible(true);
  };

  return (
    <FormSection>
      <Grid container spacing={2}>
        <Grid size={{ md: 12, xl: 3 }}>
          <BigFormRow>
            <TextInput source="sender" label="From" disabled />
            <TextInput source="recipient" label="To" disabled />
            {isCcInputVisible ? (
              <CommaListInput source="ccs" label="CC (enter comma-separated e-mail addresses)" />
            ) : (
              <Button type="button" size="small" sx={{ mb: 1 }} onClick={showCcInput} startIcon={<AddIcon />}>
                Add CC
              </Button>
            )}
            <TextInput source="subject" />
          </BigFormRow>
        </Grid>
        <Grid size={{ md: 12, xl: 9 }}>
          <BigFormRow className="mail-edit">
            <WysiwygInput source="content" label="" />
          </BigFormRow>
        </Grid>
        <Grid size={{ md: 12, xl: 9 }}>
          <BigFormRow>
            <EmailAttachmentUploaderInput
              label=""
              source="attachmentIds"
              artifactTypeId={emailAttachmentArtifactTypeId}
            />
          </BigFormRow>
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default SendEmailForm;
